import { Injectable, NgZone } from '@angular/core';
import { fromEvent, merge, timer, Subscription } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { getEnvironment } from '../environment/environment';

@Injectable({
  providedIn: 'root'
})
export class UserIdleService {
  env = getEnvironment();

  private timeoutInMs: number = 0.1 * 60 * 1000; // 5 minutos
  private userActivityEvents = ['mousemove', 'keydown', 'click', 'scroll'];
  private idleSubscription: Subscription | null = null;

  constructor(private ngZone: NgZone) {
    this.timeoutInMs = (this.env.logoutTime?.time ?? 0) * 60 * 1000;
  }

  startWatching(onIdleCallback: () => void) {
    this.ngZone.runOutsideAngular(() => {
      const activityEvents$ = merge(
        ...this.userActivityEvents.map(event =>
          fromEvent(window, event)
        )
      );

      this.idleSubscription = activityEvents$.pipe(
        tap(() => console.log('')),//dectado
        switchMap(() => timer(this.timeoutInMs))
      ).subscribe(() => {
        this.ngZone.run(() => {
          //console.warn('Usuario inactivo');
          onIdleCallback();
        });
      });
    });
  }

  stopWatching() {
    this.idleSubscription?.unsubscribe();
    this.idleSubscription = null;
  }
}
